import React from 'react'
import { useTranslation } from 'react-i18next'

import TriggerSentence from '../../../../../../../containers/triggers/TriggerSentence'
import Text from '../../../../../../../packages/kiti/components/presentation/Text'
import DataTable from '../../../../../../../packages/kiti/components/table/DataTable'

const TriggersTable = ({ data, ...props }) => {
  const { t } = useTranslation('editChecklist')
  const columns = [
    {
      label: t('folder'),
      sortIndex: false,
      flex: 1.5,
      render: (_, record) => (
        <Text bold size="p">
          {record?.folder?.name || t('noFolder')}
        </Text>
      )
    },
    {
      label: t('common:name'),
      sortIndex: false,
      flex: 10,
      render: (_, record) => (
        <>
          {record.name ? (
            <Text bold size="p">
              {record.name}
            </Text>
          ) : (
            <TriggerSentence trigger={record} />
          )}
        </>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" {...props} />
}

export default TriggersTable
